module.exports = __webpack_public_path__ + "static/media/Screenshot_1-thumb.f6f98cb1.png";